/**
 * @license
 * Copyright Google LLC All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.dev/license
 */

// THIS CODE IS GENERATED - DO NOT MODIFY.
const u = undefined;

function plural(val: number): number {
const n = val;

return 5;
}

export default ["wo",[["Sub","Ngo"]],u,[["Dib","Alt","Tal","Àla","Alx","Àjj","Ase"],u,["Dibéer","Altine","Talaata","Àlarba","Alxamis","Àjjuma","Aseer"],["Dib","Alt","Tal","Àla","Alx","Àjj","Ase"]],u,[["1","2","3","4","5","6","7","8","9","10","11","12"],["Sam","Few","Mar","Awr","Mee","Suw","Sul","Ut","Sàt","Okt","Now","Des"],["Samwiyee","Fewriyee","Mars","Awril","Mee","Suwe","Sulet","Ut","Sàttumbar","Oktoobar","Nowàmbar","Desàmbar"]],u,[["JC","AD"],u,["av. JC","AD"]],1,[6,0],["dd-MM-y","d MMM, y","d MMMM, y","EEEE, d MMM, y"],["HH:mm","HH:mm:ss","HH:mm:ss z","HH:mm:ss zzzz"],["{1} - {0}",u,u,u],[",",".",";","%","+","-","E","×","‰","∞","NaN",":"],["#,##0.###","#,##0%","¤ #,##0.00","#E0"],"XOF","F CFA","Franc CFA bu Afrik Sowwu-jant",{"CLP":[u,"Vote $"],"EGP":["EGPP","E£"],"GHS":["GHS.","GH₵"],"GIP":["GIIP","£"],"GTQ":["GT Q","Q"],"HRK":["HRKS","kn"],"HUF":[u,"Vote Ft"],"JPY":["JP¥","¥"],"MDL":["Vote MDL"],"NGN":["NGN.","₦"],"RON":[u,"Vote lei"]},"ltr", plural];
